import {
  REQUEST_DONATION_CATEGORY_LIST_WITH_CHILDREN
} from './mutation-types'

export default {
  [REQUEST_DONATION_CATEGORY_LIST_WITH_CHILDREN](state, receivedData) {
    state.donationCategoryListWithChildren = receivedData
  }
}